import { loading, error, success } from 'State/actions';
import { getControlInfo } from 'State/controlInfo/actions';
import { getCaseTypes } from 'State/caseTypes/actions';
import * as types from './types';
import {
  DC_IMPORT_FETCHING,
  DC_IMPORT_FETCH_ERROR,
  DC_IMPORT_SAVE_SELECTED_CONFIG,
} from '../common/types';
import { DC_SET_REDIRECT_HOME } from '../fileconfig/types';
import { DCImportTypes } from '../../helpers/Constants';
import { createToast, toastType } from 'Common/ToastHelper';
import { clearImportFile } from '../common/actions';

export const getConfigList = (redirect) => {
  return async (dispatch, getState, MPWWebApi) => {
    const response = await MPWWebApi.postGenericInsertUpdate(
      `ImportConfiguration/ByType`,
      DCImportTypes
    );
    dispatch({
      type: types.DC_IMPORT_SAVE_CONFIG_LIST,
      payload: response.data.Data,
    });
    if (redirect) {
      dispatch(setRedirectHome(true));
    }
  };
};

export const getUnmatchedCount = () => {
  return async (dispatch, getState, MPWWebApi) => {
    const response = await MPWWebApi.getGeneric(
      `DirectCertificationExempt/GetUnmatchedCount`
    );
    dispatch({
      type: types.DC_IMPORT_SAVE_UNMATCHED_COUNT,
      payload: response.data.Data,
    });
  };
};

export const analyzeFile = (file, ApplicationDate, ImportConfigurationId) => {
  return async (dispatch, getState, MPWWebApi) => {
    let formData = new FormData();

    formData.append('import_file', file);
    formData.append('ApplicationDate', ApplicationDate);
    formData.append('ImportConfigurationId', ImportConfigurationId);

    dispatch(loading(DC_IMPORT_FETCHING, true));
    try {
      const response = await MPWWebApi.postGenericFile(
        'DirectCertificationExempt/Analyze',
        formData,
        dispatch
      );

      dispatch(setAnalysisResult(response.data.Data));
    } catch (err) {
      if (err) {
        err.response.data.Errors.forEach((error) =>
          createToast(toastType.error, 'Error', error.Message)
        );
        dispatch(error(DC_IMPORT_FETCH_ERROR, err));
      } else {
        createToast(toastType.error, 'Error', 'Analyze Settings failed.');
      }
    }
    dispatch(loading(DC_IMPORT_FETCHING, false));
  };
};

export const queueImport = (importRecordId) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.DC_IMPORT_SUBMITTING, true));

    try {
      await MPWWebApi.postGenericInsertUpdate(
        `DirectCertificationExempt/Import/${importRecordId}`
      );

      dispatch(success(types.DC_IMPORT_QUEUE_SUCCESS));
    } catch (ex) {
      dispatch(error(types.DC_IMPORT_QUEUE_ERROR, ex));
    }

    dispatch(loading(types.DC_IMPORT_SUBMITTING, false));
  };
};

export const fetchLookups = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(DC_IMPORT_FETCHING, true));

      await dispatch(getControlInfo(false));
      await dispatch(getCaseTypes());

      dispatch(loading(DC_IMPORT_FETCHING, false));
    } catch (ex) {
      dispatch(error(DC_IMPORT_FETCH_ERROR, ex));
    }
  };
};

export const saveSelectedConfig = (data, name, id) => {
  return async (dispatch) => {
    dispatch({
      type: DC_IMPORT_SAVE_SELECTED_CONFIG,
      payload: { data, name, id },
    });
  };
};

export const setAnalysisResult = (value) => {
  return {
    type: types.DC_SET_ANALYSIS_RESULT,
    payload: value,
  };
};

export const setFileConfirmedOk = (value) => {
  return {
    type: types.DC_SET_FILE_CONFIRMED_OK,
    payload: value,
  };
};

export const setRedirectHome = (value) => {
  return {
    type: DC_SET_REDIRECT_HOME,
    payload: value,
  };
};

export const clearAnalyzeResults = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(setFileConfirmedOk(false));
    dispatch(setAnalysisResult(null));
    dispatch(clearImportFile());
  };
};

export const clearImporStatusError = () => {
  return {
    type: types.DC_IMPORT_CLEAR_QUEUE_ERROR,
  };
};



// WEBPACK FOOTER //
// ./src/pages/dcimport/state/hub/actions.js